import React, { useState } from 'react';
import './ImageUpload.css';

const ImageUpload = ({ onImageSelect, currentImage, label, multiple = false }) => {
  const [preview, setPreview] = useState(currentImage || null);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    
    if (multiple) {
      const previews = files.map(file => URL.createObjectURL(file));
      setPreview(previews);
      onImageSelect(files);
    } else {
      const file = files[0];
      if (file) {
        const previewUrl = URL.createObjectURL(file);
        setPreview(previewUrl);
        onImageSelect(file);
      }
    }
  };

  return (
    <div className="image-upload">
      <label className="image-upload-label">{label}</label>
      <div className="image-upload-container">
        {preview && !multiple && (
          <div className="image-preview">
            <img src={preview} alt="Preview" />
          </div>
        )}
        {multiple && preview && Array.isArray(preview) && (
          <div className="image-gallery-preview">
            {preview.map((img, index) => (
              <div key={index} className="gallery-preview-item">
                <img src={img} alt={`Preview ${index}`} />
              </div>
            ))}
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          multiple={multiple}
          className="image-upload-input"
          id={`image-upload-${label}`}
        />
        <label htmlFor={`image-upload-${label}`} className="image-upload-button">
          Выбрать изображение
        </label>
      </div>
    </div>
  );
};

export default ImageUpload;